import styled, { css } from "styled-components";
import { colors } from "theme/colors";
import { TabProps } from "./types";

export const TabSelectionWrapper = styled.div`
    display: flex;
    border-radius: 30px;
    width: fit-content;
    box-shadow: 0px 4px 14px rgba(136, 104, 234, 0.15);
    transition: all 100ms ease-out;
    * {
        transition: all 100ms ease-out;
    }
`;

const TabColor = ({ isActive }: TabProps) => {
    return css`
        color: ${isActive ? "#fff" : colors.grey.primary};
        background-color: ${isActive ? colors.purple.primary : "#fff"};
    `;
};

export const Tab = styled.span<TabProps>`
    color: ${colors.grey.primary};
    padding: 10px 14px;
    border-radius: 30px;
    cursor: pointer;
    ${TabColor};
`;
